import { inr } from '@/lib/loan';

export default function StatsCards({ stats }) {
  const cards = [
    { label: 'Total applications', value: stats.total, testid: 'admin-stat-total' },
    { label: 'Under review', value: stats.by_status.under_review || 0, testid: 'admin-stat-review' },
    { label: 'Approved', value: stats.by_status.approved || 0, testid: 'admin-stat-approved' },
    { label: 'Disbursed', value: stats.by_status.disbursed || 0, testid: 'admin-stat-disbursed' },
    { label: 'Requested (₹)', value: inr(stats.total_requested), testid: 'admin-stat-requested' },
    { label: 'Last 7 days', value: stats.last7, testid: 'admin-stat-last7' },
  ];
  return (
    <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6" data-testid="admin-stats">
      {cards.map((c) => (
        <div key={c.label} className="rounded-xl border border-white/10 bg-panel/60 p-4">
          <p className="font-mono text-xl font-bold text-pulse" data-testid={c.testid}>{c.value}</p>
          <p className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-slate-500">{c.label}</p>
        </div>
      ))}
    </div>
  );
}
